export const getClientSdkErrorMessage = (error: unknown): string => {
  // 1. If it's an Error-like object with a message --> expected at the moment 23.7.2025
  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
    return error.message;
  }

  // 2. If it's a string
  if (typeof error === 'string') {
    return error;
  }

  // 3. If it's an object with a custom toString (not default)
  if (error && typeof error === 'object') {
    const toStringFn = (error as { toString?: unknown }).toString;

    if (typeof toStringFn === 'function') {
      const str = toStringFn.call(error);

      if (str && str !== '[object Object]') {
        return str;
      }
    }
    // 4. Fallback: JSON.stringify if toString is not informative
    try {
      const json = JSON.stringify(error);

      if (json !== '{}') {
        return json;
      }
    } catch {
      // ignore
    }
  }

  // 5. Final fallback
  return 'Unknown error';
};

export const isClientSdkUserCancellation = (errorMessage: string): boolean =>
  errorMessage === 'user timeout' ||
  errorMessage === 'User rejected the request.' ||
  /^You rejected Ducat (message|transaction|batch) signing\.$/.test(errorMessage) ||
  errorMessage === 'You rejected Ducat transfer.';
